module.exports = __webpack_public_path__ + "img/fig2.a8edd9ee.svg";